import { render, staticRenderFns } from "./ShiftRequirements.vue?vue&type=template&id=7854f890"
import script from "./ShiftRequirements.js?vue&type=script&lang=js&external"
export * from "./ShiftRequirements.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports